import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { Api } from './api.service';
import { WebApi } from './web-api.service';
import { ConsumptionService } from 'app/services/consumption.service';
import { ApplicationsService } from 'app/applications/applications.service';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        Api,
        WebApi,
        ConsumptionService
    ]
})
export class CoreModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: CoreModule,
            providers: [ApplicationsService]
        }
    }
}